import React, { useEffect, useState } from 'react'

import api from '@/services/api'
import apiEndPoints from '@/consts/apiEndPoints'
import handleErrors from '@/services/handleErrors'

import TextField from 'components/TextField'
import ComboboxBase from '../Base'

export function ComboboxCollectStatus(props) {
  const [options, setOptions] = useState([])

  useEffect(() => {
    async function loadCollectStatus() {
      try {
        const response = await api.get(
          apiEndPoints.user.orderCollects.collectStatus
        )

        setOptions(
          [{ label: 'TODOS', value: '' }].concat(
            response.data.map((status) => ({
              value: status.id,
              label: status.title?.toUpperCase(),
            }))
          )
        )
      } catch (error) {
        handleErrors(error, 'Não foi possível buscar os status')
      }
    }

    loadCollectStatus()
  }, [])

  return (
    <ComboboxBase
      name="collect_status"
      options={options}
      renderInput={(provided) => (
        <TextField label="Status" variant="outlined" {...provided} />
      )}
      disableClearable
      {...props}
    />
  )
}
